// extracted by mini-css-extract-plugin
export default {"number":"RjG2B","hyphen":"SbMh3","gpm-slider-only":"wnfRL","gpm-slider-with-percentage":"Bptt1"};